import { render, staticRenderFns } from "./nodeal.vue?vue&type=template&id=4d7d04a0"
import script from "./nodeal.vue?vue&type=script&lang=js"
export * from "./nodeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports